import { render, staticRenderFns } from "./chainPage1.vue?vue&type=template&id=72a1fb7b&scoped=true"
import script from "./chainPage1.vue?vue&type=script&lang=js"
export * from "./chainPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1fb7b",
  null
  
)

export default component.exports